import React from 'react';
import { Link } from 'react-router-dom';


const Argitechmain = () => {
    const cards = [
      
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553587/image-1_kma4ur.png",
            link: "/argitech2",

            label: "SMART FARMING",
            description: "SMART Chicken farming",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745008803/image_35_d1uume.png",
            link: "/argitech6",

            label: "SMART FARMING",
            description: "SMART Chicken farming",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/image-2_b1tpiy.png",
            label: "AGRITECH",
            link: "/argitech3",
            description: "Agritech, the future of agriculture",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/image-3_wupnyl.png",
            link: "/argitech4",


        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553589/image-4_nlf8wa.png",
            link: "/argitech5",
            label: "FOOD SECURITY",

            description: "Innovation for\nsustainable future",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745008802/image_36_eupz7n.png",
            link: "/argitech7",
            label: "SMART FARMING",
            description: "SMART Chicken farming",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/Rectangle_34637092_s9qhwq.png",
            link: "/argitech4",
            label: "AGRITECH",
            description: "Agritech, the future of agriculture",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/Rectangle_34637092_s9qhwq.png",
            label: "AGRITECH",
            link: "/argitech4",
            description: "Agritech, the future of agriculture",
        },
    ];

    return (
        <div className='bg-white'>
            <div className="container mx-auto md:py-12 py-4 px-4 md:px-20">
                {/* Section Title with Icon */}
                <div className="flex justify-between items-center md:mb-8 mb-3">
                    <h1 className="font-inter font-bold text-[11px] md:text-4xl text-[#FDBD26]">AgriTech</h1>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744287925/Expand_down_hlf9gz.png"
                        alt="icon"
                        className="w-6 h-6 md:w-8 md:h-8 md:flex hidden"
                    />
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744416878/Expand_down_pm2tdq.png"
                        alt="icon"
                        className="w-4 h-4  md:hidden flex"
                    />
                </div>

                {/* Paragraph */}
                <p className="font-inter text-[11px] md:text-[40px] font-normal leading-snug md:leading-[1.30] md:mb-6 ">
                    AgriTech, or agricultural technology, refers to the application of technological innovations to improve and enhance agricultural practices. It is aimed at increasing productivity, sustainability, and efficiency in farming and food production.
                </p>

                {/* Cards Grid */}
                <div className="grid grid-cols-2 gap-x-5 md:gap-x-16 md:gap-y-4 gap-y-1">
                    {cards.map((card, index) => (
                        <Link to={card.link} key={index}>
                            <div
                                key={index}
                                className={`group rounded-lg overflow-hidden transition-all duration-300 transform hover:scale-105 ${index < 2 ? 'pt-6 md:pt-10' : 'pt-3 md:pt-5'}`}
                            >


                                {/* Image + Overlay Text */}
                                <div className="relative ">
                                    <img
                                        src={card.image}
                                        alt="card image"
                                        className="md:w-[555px] h-[110px]  w-[170px] md:h-[305px] w-full object-cover rounded-lg "
                                    />
                                    <img
                                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                                        alt="Play"
                                        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10"
                                    />
                                  
                                    <div className="absolute md:left-6 md:bottom-4 left-2 bottom-1 text-white">
                                        <h3 className={`font-inter font-semibold text-[9px] md:text-[16px]   md:mb-3 ${index === 0 ? 'text-black' : 'text-white'}`}>{card.label}</h3>
                                        <p className={`font-inter font-bold text-[9px] md:text-[24px] whitespace-pre-line ${index === 0 ? 'text-black' : 'text-white'}`} style={{ lineHeight: '1.30' }}>
                                            {card.description}
                                        </p>


                                    </div>
                                </div>
                                
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <div className='md:h-5'></div>
        </div>
    );
};

export default Argitechmain;
